import { StatusWidget } from '@revolut-internal/ui-kit'

export const AccessDeniedWidget = () => (
  <StatusWidget>
    <StatusWidget.Image
      image={{
        default: 'https://assets.revolut.com/assets/3d-images-v2/3D020.png',
        '2x': 'https://assets.revolut.com/assets/3d-images-v2/3D020@2x.png',
        '3x': 'https://assets.revolut.com/assets/3d-images-v2/3D020@3x.png',
      }}
    />
    <StatusWidget.Title>Something went wrong</StatusWidget.Title>
    <StatusWidget.Description>Access denied</StatusWidget.Description>
  </StatusWidget>
)
